export function bindModalDragPointerDown(handleEl: HTMLElement, onPointerDown: (event: PointerEvent) => void): void {
    handleEl.addEventListener("pointerdown", onPointerDown as EventListener);
}

export function bindModalDragDocumentMove(onPointerMove: (event: PointerEvent) => void): void {
    document.addEventListener("pointermove", onPointerMove as EventListener, { passive: true });
}

export function bindModalDragDocumentEnd(onEnd: (event: PointerEvent) => void): void {
    document.addEventListener("pointerup", onEnd as EventListener);
    document.addEventListener("pointercancel", onEnd as EventListener);
}

export function unbindModalDragDocumentMove(onPointerMove: (event: PointerEvent) => void): void {
    document.removeEventListener("pointermove", onPointerMove as EventListener);
}

export function unbindModalDragDocumentEnd(onEnd: (event: PointerEvent) => void): void {
    document.removeEventListener("pointerup", onEnd as EventListener);
    document.removeEventListener("pointercancel", onEnd as EventListener);
}
